import { useNotification } from "@refinedev/core";
import { CopyOutlined } from "@ant-design/icons";
import { Button, Drawer } from "antd";
import { PrismLight as SyntaxHighlighter } from "react-syntax-highlighter";
import css from "react-syntax-highlighter/dist/esm/languages/prism/css";
import markup from "react-syntax-highlighter/dist/esm/languages/prism/markup";
import javascript from "react-syntax-highlighter/dist/esm/languages/prism/javascript";
import php from "react-syntax-highlighter/dist/esm/languages/prism/php";
import oneDark from "react-syntax-highlighter/dist/esm/styles/prism/one-dark";
import oneLight from "react-syntax-highlighter/dist/esm/styles/prism/one-light";
import { use, type FC } from "react";
import { ColorModeContext } from "../../../contexts/color-mode";
import { SNIPPET_TYPE_LANGUAGE } from "../constants";
import type { SnippetRow } from "../types";

SyntaxHighlighter.registerLanguage("css", css);
SyntaxHighlighter.registerLanguage("markup", markup);
SyntaxHighlighter.registerLanguage("javascript", javascript);
SyntaxHighlighter.registerLanguage("php", php);

interface CodeDrawerProps {
  snippet: SnippetRow | null;
  onClose: () => void;
}

export const CodeDrawer: FC<CodeDrawerProps> = ({ snippet, onClose }) => {
  const { open: notify } = useNotification();
  const { mode } = use(ColorModeContext);

  return (
    <Drawer
      title={snippet?.name}
      open={Boolean(snippet)}
      onClose={onClose}
      placement="left"
      width="90%"
      extra={
        snippet && (
          <Button
            size="small"
            icon={<CopyOutlined />}
            onClick={() => {
              void navigator.clipboard.writeText(snippet.code);
              notify?.({ type: "success", message: "Copied to clipboard" });
            }}
          >
            Copy
          </Button>
        )
      }
    >
      {snippet && (
        <SyntaxHighlighter
          language={SNIPPET_TYPE_LANGUAGE[snippet.type]}
          style={mode === "dark" ? oneDark : oneLight}
          customStyle={{ margin: 0, borderRadius: 6, padding: "12px 16px", fontSize: 12 }}
          wrapLongLines
        >
          {snippet.code}
        </SyntaxHighlighter>
      )}
    </Drawer>
  );
};
